import React from 'react'

import { useRouteMatch } from 'react-router-dom'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core'

import Topbar from './components/Topbar'
import SnackbarProvider from 'providers/SnackbarProvider'
import ConfirmDialogProvider from 'providers/ConfirmDialogProvider'

import { routes } from 'routes'
import LoaderProvider from 'providers/LoaderProvider'
import Bottombar from './components/Bottombar'
import Footer from './components/Footer'
import styles from './styles'

const useStyles = makeStyles(styles)

const Subscribe = ({ children }) => {
  const classes = useStyles()
  const matchRouteSubscribeMain = useRouteMatch(routes.subscribe.main)

  const isRouteSubscribeMain = React.useMemo(
    () => matchRouteSubscribeMain && matchRouteSubscribeMain.isExact,
    [matchRouteSubscribeMain],
  )

  return (
    <SnackbarProvider>
      <LoaderProvider>
        <ConfirmDialogProvider>
          <div
            className={clsx(classes.root, {
              [classes.rootSubscribeMain]: isRouteSubscribeMain, // adicionar magin-bottom por conta da exibição do componente Bottombar
            })}
          >
            <Topbar />

            <div className={classes.content}>{children}</div>

            {isRouteSubscribeMain && <Bottombar />}
            <Footer />
          </div>
        </ConfirmDialogProvider>
      </LoaderProvider>
    </SnackbarProvider>
  )
}

export default Subscribe
